import { render, staticRenderFns } from "./videoedit.vue?vue&type=template&id=ddaba760&scoped=true"
import script from "./videoedit.vue?vue&type=script&lang=js"
export * from "./videoedit.vue?vue&type=script&lang=js"
import style0 from "./videoedit.vue?vue&type=style&index=0&id=ddaba760&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaba760",
  null
  
)

export default component.exports